import React, {Component} from 'react';
import {Col} from 'jsxstyle';
import {parse, extract, stringify} from 'query-string';

const json = 'application/json';
const isProd = process.env.NODE_ENV === 'production';
const baseUri = isProd ? 'https://api.getsnap.link' : 'http://localhost:3010';

const request = (
  uri,
  {base = baseUri, body, type = 'json', method = 'GET', headers = {}} = {}
) => {
  const isJSON = type === 'json';
  const init = {
    body: isJSON ? JSON.stringify(body) : body,
    method,
    headers: isJSON
      ? {
          Accept: json,
          'Content-Type': json,
          ...headers
        }
      : headers
  };

  return fetch(`${base}${uri}`, init)
    .then(response => {
      const contentType = response.headers.get('Content-Type');
      const body =
        contentType && contentType.indexOf(json) !== -1
          ? response.json()
          : response.text();

      return response.status < 300 ? body : Promise.reject(body);
    })
    .then(data => ({data}))
    .catch(error => ({error}));
};

export default request;

export const getQuery = ({search, extra}) => {
  const {
    u, // eslint-disable-line no-unused-vars
    v, // eslint-disable-line no-unused-vars
    ch, // eslint-disable-line no-unused-vars
    pn, // eslint-disable-line no-unused-vars
    vn, // eslint-disable-line no-unused-vars
    vc, // eslint-disable-line no-unused-vars
    lang, // eslint-disable-line no-unused-vars
    bucket, // eslint-disable-line no-unused-vars
    nsukey, // eslint-disable-line no-unused-vars
    region, // eslint-disable-line no-unused-vars
    isPremium, // eslint-disable-line no-unused-vars
    random_id, // eslint-disable-line no-unused-vars
    networkCountryIso, // eslint-disable-line no-unused-vars
    ...queries
  } = parse(extract(search));

  return stringify({
    ...queries,
    ...extra
  });
};

export const shortenUri = async ({uri} = {}) => {
  const init = {
    base: 'https://getsnap.link',
    body: {url: uri},
    method: 'POST'
  };
  const {data, error} = await request('/generate', init);

  if (data) {
    return data.shortUrl;
  } else {
    throw error;
  }
};

export const withRequest = (uri, options) => WrappedComponent => {
  switch (typeof uri) {
    case 'string':
    case 'function':
      return class WithRequest extends Component {
        state = {
          data: null,
          error: null,
          isLoading: true
        };

        async componentWillMount() {
          const finalUri = typeof uri === 'function' ? uri(this.props) : uri;

          if (finalUri == null) {
            this.setState({isLoading: false});
          } else {
            const {data, error} = await request(finalUri, options);

            this.setState({data, error, isLoading: false});
          }
        }

        componentDidMount() {
          window._spinner.spin(this._loading);
        }

        componentDidUpdate(_, {isLoading}) {
          if (isLoading !== this.state.isLoading) {
            if (this.state.isLoading && this._loading) {
              window._spinner.spin(this._loading);
            }

            if (!this.state.isLoading) {
              window._spinner.stop();
            }
          }
        }

        setLoadingRef = ref => (this._loading = ref);

        render() {
          const {isLoading} = this.state;

          return isLoading ? (
            <Col
              props={{ref: this.setLoadingRef}}
              top="0"
              left="0"
              right="0"
              bottom="0"
              zIndex={2e9}
              position="absolute"
            />
          ) : (
            <WrappedComponent {...this.props} request={this.state} />
          );
        }
      };

    default:
      return WrappedComponent;
  }
};



// WEBPACK FOOTER //
// ./components/request.js